// extracted by mini-css-extract-plugin
export default {"root":"styles-root-e4dbec"};